import React from "react";
import {
  Box,
  Card,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";

// Duo/trio with single spots: book the whole lesson or just one spot.
// Once someone takes a spot the whole booking is gone; when all spots are
// taken the spot option leads to the waitlist.
const DuoModePicker = ({
  value,
  onChange,
  perBooking,
  wholePrice,
  spotPrice,
  freeSpots,
  wholeAvailable,
  spotAvailable,
}) => {
  const options = [
    {
      mode: "whole",
      testId: "duo-mode-whole",
      title: "Cała rezerwacja",
      subtitle: `Rezerwujesz całe zajęcia (${perBooking} os.)`,
      price: wholePrice,
      disabled: !wholeAvailable,
      caption: !wholeAvailable ? "Ktoś już zarezerwował miejsce" : null,
    },
    {
      mode: "spot",
      testId: "duo-mode-spot",
      title: "Jedno miejsce",
      subtitle: "Rezerwujesz miejsce tylko dla siebie",
      price: spotPrice,
      disabled: false,
      caption:
        spotAvailable && freeSpots != null
          ? `Wolne miejsca: ${freeSpots}/${perBooking}`
          : !spotAvailable
            ? "Brak wolnych miejsc – lista rezerwowa"
            : null,
    },
  ];

  return (
    <FormControl component="fieldset" sx={{ width: "100%" }} data-testid="duo-mode-picker">
      <FormLabel component="legend" sx={{ mb: 1.5, fontWeight: 600 }}>
        Co rezerwujesz?
      </FormLabel>
      <RadioGroup name="duo-mode" value={value} onChange={(e) => onChange(e.target.value)}>
        <Stack spacing={1}>
          {options.map((o) => {
            const selected = value === o.mode;
            return (
              <Card
                key={o.mode}
                elevation={0}
                data-testid={o.testId}
                sx={{
                  border: selected ? "2px solid #2196f3" : "1px solid #e0e0e0",
                  backgroundColor: selected ? "#e3f2fd" : "transparent",
                  opacity: o.disabled ? 0.6 : 1,
                  transition: "all 0.2s",
                  "&:hover": o.disabled ? {} : { borderColor: "#2196f3" },
                }}
              >
                <FormControlLabel
                  value={o.mode}
                  disabled={o.disabled}
                  control={<Radio />}
                  label={
                    <Box sx={{ py: 0.5, display: "flex", justifyContent: "space-between", gap: 1, alignItems: "center" }}>
                      <Box sx={{ minWidth: 0 }}>
                        <Typography variant="body2" fontWeight="600">
                          {o.title}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                          {o.subtitle}
                        </Typography>
                        {o.caption && (
                          <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                            {o.caption}
                          </Typography>
                        )}
                      </Box>
                      {o.price != null && (
                        <Typography variant="body1" fontWeight="bold" color="primary" sx={{ flexShrink: 0 }}>
                          {o.price} zł
                        </Typography>
                      )}
                    </Box>
                  }
                  sx={{
                    m: 0,
                    p: 1.5,
                    width: "100%",
                    "& .MuiFormControlLabel-label": { width: "100%" },
                  }}
                />
              </Card>
            );
          })}
        </Stack>
      </RadioGroup>
    </FormControl>
  );
};

export default DuoModePicker;
